import { Menu, Search } from 'lucide-react';
import { useState } from 'react';

import { Button } from '../components/Button';
import { Input } from '../components/Input';
import { ThemeToggle } from './ThemeToggle';

interface HeaderProps {
    onToggleSidebar: () => void;
}

export function Header({ onToggleSidebar }: HeaderProps) {
    const [globalSearch, setGlobalSearch] = useState('');

    return (
        <header className="sticky top-0 z-20 flex h-14 shrink-0 items-center gap-2 border-b border-solid border-gray-200 bg-white px-3 dark:border-gray-700 dark:bg-gray-800 sm:gap-3 sm:px-4">
            <Button
                variant="ghost"
                size="sm"
                className="lg:hidden"
                onClick={onToggleSidebar}
                aria-label="Deschide meniul"
            >
                <Menu aria-hidden="true" className="h-5 w-5" />
            </Button>
            <div className="text-sm font-semibold text-gray-900 dark:text-gray-100">Orchestrator</div>
            <div className="flex flex-1 justify-center px-2 sm:px-4">
                <div className="hidden w-full max-w-xl sm:block">
                    <Input
                        type="search"
                        icon={Search}
                        placeholder="Cauta oriunde... (text, imagine, cod de bare)"
                        value={globalSearch}
                        onChange={(e) => setGlobalSearch(e.target.value)}
                        aria-label="Cauta global"
                    />
                </div>
            </div>
            <ThemeToggle />
            <a
                href="/dashboard"
                className="hidden text-xs text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 md:inline"
            >
                Inapoi la versiunea clasica
            </a>
        </header>
    );
}
